<div *ngIf='ready'>
  <app-select
    (selection)='onSelection($event)'
    *ngIf='useSelector'
    [defaultValue]='data.group_id'
    [items]='getGroups()'
    label='Select group'></app-select>
  <span *ngIf='!useSelector'>{{ data.group_name }}</span>
</div>
